import type { TenderCaseListItemApi } from "@/api/tender-api"

/**
 * "Involved" = the current user owns, or is an active participant on, the case.
 *
 * Tender cases are open to read for everyone, so `admin_default` (admin
 * fallback) and `viewer` (open read-only) access do NOT count as involvement.
 * Used to drive the "My cases" filter and the personal sidebar worklist.
 */
export function isInvolvedCase(item: TenderCaseListItemApi): boolean {
  const src = item.currentUserAccessSource
  if (src != null) return src === "owner" || src === "participant"
  // Legacy items without an access source: a stored role implies involvement.
  return item.currentUserRole != null
}
